import ScrollMagic from 'scrollmagic';
import { TweenMax, TimelineMax } from "gsap/all";
require('animation.gsap');
import { getViewportProperties } from '../layout/layout'
import debounce from 'lodash/debounce';


/* HERO VIDEO */

const heroVideo = document.getElementById('hero__video');
const heroVideocover = document.getElementById('hero__video-cover');
const heroVideoToggle = document.getElementById('hero__video-toggle');
if( heroVideo && heroVideoToggle ){

    // play video after a delay
    heroVideo.load();
    heroVideo.addEventListener('canplay',(event)=>{
        setTimeout(()=>{
            heroVideo.play();
            heroVideoToggle.classList.add('hero__video-toggle--playing');
        },3000);
    });

    // show video cover when its playing
    if(heroVideocover){
        heroVideo.addEventListener('playing',(event)=>{
            heroVideocover.classList.add('hero__video-cover--active');
        });
    }

    // video toggle
    heroVideoToggle.addEventListener('click',(event)=>{
        if( heroVideo.paused ){
            heroVideo.play();
            heroVideoToggle.classList.add('hero__video-toggle--playing');
        } else {
            heroVideo.pause();
            heroVideoToggle.classList.remove('hero__video-toggle--playing');
        }
    });
}



/* SCROLLMAGIC */


const homeIntro = document.getElementById('intro');
const homeVisit = document.getElementById('visit');
let homepageController = null;

const initScrollMagic = ()=>{

    const viewportProperties = getViewportProperties();
    // console.log( viewportProperties.orientation);

    if( ( homeIntro || homeVisit ) && ( viewportProperties.orientation == 'landscape' &&  viewportProperties.width > 767 ) ) {
        // USE SCROLLMAGIC
        // console.log('setup scrollmagic');

        // if there's no homepageController, set it up
        if( !homepageController ){

            homepageController = new ScrollMagic.Controller();

            if( homeIntro ){
                // intro in
                new ScrollMagic.Scene({
                    duration: '100%',
                    triggerElement: '#intro',
                    triggerHook: 'onEnter',
                })
                .setTween(
                    TweenMax.fromTo('.home__intro-content-column', 1, {y:'-30%'},{y:'0%'})
                )
                .addTo(homepageController);
                // intro out
                new ScrollMagic.Scene({
                    duration: '100%',
                    triggerElement: '#intro',
                    triggerHook: 'onLeave',
                })
                .setTween(
                    TweenMax.fromTo('.home__intro-content-column', 1, {y:'0%'},{y:'30%'})
                )
                .addTo(homepageController);

                new ScrollMagic.Scene({
                    duration: '100%',
                    triggerElement: '#intro',
                    triggerHook: 'onEnter',
                })
                .setTween(
                    TweenMax.fromTo('.home__intro-image-column', 1, {y:'-50%'},{y:'0%'})
                )
                .addTo(homepageController);
                // intro out
                new ScrollMagic.Scene({
                    duration: '100%',
                    triggerElement: '#intro',
                    triggerHook: 'onLeave',
                })
                .setTween(
                    TweenMax.fromTo('.home__intro-image-column', 1, {y:'0%'},{y:'50%'})
                )
                .addTo(homepageController);
            }

            if ( homeVisit ) {
                new ScrollMagic.Scene({
                    duration: '100%',
                    triggerElement: '#visit',
                    triggerHook: 'onEnter',
                })
                .setTween(
                    TweenMax.fromTo('.home__visit-image', 1, {y:'-10%'},{y:'0%'})
                )
                .addTo(homepageController);
                // intro out
                /**/
                new ScrollMagic.Scene({
                    duration: '100%',
                    triggerElement: '#visit',
                    triggerHook: 'onLeave',
                })
                .setTween(
                    TweenMax.fromTo('.home__visit-image', 1, {y:'0%'},{y:'30%'})
                )
                .addTo(homepageController);
                
            }


        }
    } else {

        // REMOVE SCROLLMAGIC
        if( homepageController ){
            homepageController.destroy(true);
            homepageController = null;
            if( homeIntro ){
                const introContentColumn = homeIntro.querySelector('.home__intro-content-column');
                if( introContentColumn ){
                    introContentColumn.style.transform = 'none';
                }
                const introimageColumn = homeIntro.querySelector('.home__intro-image-column');
                if( introimageColumn ){
                    introimageColumn.style.transform = 'none';
                }
            }
            if( homeVisit ){
                const visitImage = homeVisit.querySelector('.home__visit-image');
                if( visitImage ){
                    visitImage.style.transform = 'none';
                }
            }
            // console.log('remove scrollmagic');
        }
        
    }


}



// Set up ScrollMagic on load
initScrollMagic();


window.addEventListener('resize', debounce(  ()=>{
    initScrollMagic();
  }, 150) ); 












